// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXpl } from "../../../icons/full/build/icon-xpl.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XplIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXpl.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XplIcon.displayName = 'XplIcon';
}

export default XplIcon;